module.exports = __webpack_public_path__ + "f9c33b6d25919ca1c0b673a0e70d0d03.fbx";